import { createFileRoute } from '@tanstack/react-router'

import {
    BookingCtaSection,
    DownloadAppSection,
    EventsSection,
    Footer,
    Header,
    HeroSection,
    LifestyleProgramsSection,
    TestimonialsSection,
} from '../components/landing'
import { buildOgMeta } from '../utils/og'

const LandingPage = () => {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main className="flex flex-col">
                <HeroSection />
                <LifestyleProgramsSection contentKey="PACKAGES" />
                <BookingCtaSection />
                <EventsSection />
                <TestimonialsSection />
                <DownloadAppSection />
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/')({
    component: LandingPage,
    loader: async ({ context }) => {
        const [, , , websiteSettings] = await Promise.allSettled([
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.event.getPublicEvents.ensureData(),
            context.apiUtils.lifestyleProgram.getPublicList.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: websiteSettings.status === 'fulfilled' ? websiteSettings.value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title:
                loaderData?.websiteSettings?.ogTitle ||
                'Long-Y - Hosszabb \u00e9let, jobb min\u0151s\u00e9gben',
            description:
                loaderData?.websiteSettings?.ogDescription ||
                'Tudom\u00e1nyosan megalapozott longevity programok, premium kieg\u00e9sz\u00edt\u0151k \u00e9s exkluz\u00edv \u00e9letm\u00f3d t\u00e1borok.',
            imageId: loaderData?.websiteSettings?.ogImageId,
            url: import.meta.env.VITE_WEB_URL || '/',
        }),
    }),
})
